import { InnerHtmlWrapper } from '@components'

interface EventContentProps {
  bodyContent?: string
}

export const EventContent = ({ bodyContent }: EventContentProps) => {
  return <>{bodyContent && <InnerHtmlWrapper content={bodyContent} />}</>
}
